import { Tank } from './Tank';

export class AdjacentTank {
    constructor(adjacentTankId: number | null, side: number | null) {
        this.adjacentTankId = adjacentTankId;
        this.side = side;
    }
    adjacentTankId: number | null;
    side: number | null;
    tank: Tank | null;
}
